import Thankyou from "../../common/ThankyouPage/Thankyou.jsx";
import React, { Component } from "react";
import Header from "../../common/Header/HeaderMain";
import Footer from "../../common/Footer/FooterMain";
import { WIDGETS } from "../../../../constants/common";
class DisaggThankyouPage extends Component {

  componentDidMount() {
    window.scrollTo(0, 50);
  }

  render() {
    return (
      <>
        <div className="disagg-thankyou" data-widget-name={WIDGETS.FAQ} data-bg-color="color_7" data-border-color="color_43">
          <Header configs={this.props.configs}/>
          <Thankyou userObj={this.props.userObj} translations={this.props.translations} />
          <Footer
            configs={this.props.configs}
            translations={this.props.translations}
            footerNote={this.props.translations.data["FOOTER.FAQ_PAGE.FOOTER_NOTE"]}
            queryParams={this.props.queryParams}
            uuid={this.props.userObj.details.uuid}
          />
        </div>
      </>
    );
  }
}

export default DisaggThankyouPage;
